import React, { Component } from 'react';

import Sidebar from './Sidebar';
import Question from './Question';
import Navigation from './Navigation';
import JobSearch from './JobSearch';


export default class extends Component {

    componentDidMount() {
        this.animatePage();
        this.props.setWhiteLogo(true);
    }

    animatePage() {
        const questionPage = document.getElementById('QuestionPage');
        setTimeout(() => {
            questionPage.classList.add('__active');
        }, 10);
    }

    render() {
        const { categories, updateCategoryQuestion, soc, setSoc, jobTitle, isQuizComplete } = this.props; 
        const categoryID = parseInt(this.props.match.params.id);
        const categoryData = categories.find(category => category.category.id == categoryID);
        const jobSecurityCondition = categoryID == 9 && (categoryData.dynamic && categoryData.subQuestions[0].answer != 0);
        
        return (
            <div className="questionpage" id="QuestionPage">
                <div className="row h-100 no-gutters">
                    <div className="col-lg-5 h-100">
                        {categoryID != 11 && categoryData ? (
                            <Sidebar categoryID={categoryID} categoryData={categoryData} />
                        ) : (
                            <Sidebar categoryID={categoryID} title="" category="" />
                        )}
                    </div>
                    <div className="col-lg-7 h-100">
                        {jobSecurityCondition && (
                            <div className="questionpage-wrap">
                                <h3 className="questionpage-title" dangerouslySetInnerHTML={{__html: categoryData.title}}/>
                                <Question 
                                    updateCategoryQuestion={updateCategoryQuestion} 
                                    categoryID={categoryID} 
                                    key={categoryData.subQuestions[0].id} 
                                    question={categoryData.subQuestions[0]} 
                                    questionIndex="0" 
                                />

                                <Question
                                    updateCategoryQuestion={updateCategoryQuestion}
                                    categoryID={categoryID}
                                    key={categoryData.subQuestions[2].id}
                                    question={categoryData.subQuestions[2]}
                                    questionIndex="2"
                                />
                            </div>
                        )}

                        {!jobSecurityCondition && (
                            categoryID != 11 && categoryData ? (
                                <div className="questionpage-wrap">
                                    <h3 className="questionpage-title" dangerouslySetInnerHTML={{__html: categoryData.title}}/>
                                    { categoryData.dynamic && categoryData.subQuestions[0].answer != 0 ? ( 
                                        <Question updateCategoryQuestion={updateCategoryQuestion} categoryID={categoryID} key={categoryData.subQuestions[0].id} question={categoryData.subQuestions[0]} questionIndex="0" />
                                    ) : categoryData.subQuestions.map((question, index) =>
                                        <Question updateCategoryQuestion={updateCategoryQuestion} categoryID={categoryID} key={question.id} question={question} questionIndex={index} />)
                                    }
                                </div>
                            ) : (
                                <div className="questionpage-wrap __job">
                                    <JobSearch setSoc={setSoc} jobTitle={jobTitle} />
                                </div>
                            )
                        )}
                    </div>
                </div>
                <div className="questionpage-navigation">
                    {categoryID && (
                        <Navigation isQuizComplete={isQuizComplete} categoryID={categoryID} soc={soc} categoryData={categoryData} />
                    )}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Question/index.js